import { Sorter } from '@process-creative/slate-ajax-collection';
import { t } from '@process-creative/slate-theme-tools';

const ATTR_SORT_VALUE = 'data-sort-value';

export class CustomSelectSorter extends Sorter {
  constructor({ template, sortElem, sortMethods }) {
    super(template);
    this.template = template;
    this.sortElem = sortElem;
    this.sortMethods = sortMethods;

    // Initialize the checkbox sorter
    this.initializeSorter();
  }


  initializeSorter() {
    // Generate the checkbox HTML and insert it into the element
    this.renderSortOptions();
    
    // Bind click events
    $(this.sortElem).on('click', `[${ATTR_SORT_VALUE}]`, (e) => this.onSortChange(e));
    $(this.sortElem).on('click', 'label[for^="sort-checkbox-"]', (e) => this.onLabelClick(e));
  }

  renderSortOptions() {
    const currentSort = this.template.sort.currentSort || this.template.sort.defaultSortBy;
    const currentSortHandle = currentSort?.handle || currentSort;
    
    const sortOptionsHtml = Object.values(this.sortMethods).map((sortMethod, index) => {
      // Skip invalid elements
      if (!sortMethod || !sortMethod.isVisible) return '';
      if (!sortMethod.isVisible(this.template)) return '';

      const isSelected = currentSortHandle === sortMethod.handle;
      
      return `
        <li class="c-collection-faceted-nav__option is-radio o-heading--7" data-faceted-check-item>
          <input
            type="checkbox"
            class="c-facets__input c-collection-faceted-nav__option-input"
            id="sort-checkbox-${sortMethod.handle}"
            ${ATTR_SORT_VALUE}="${sortMethod.handle}"
            ${isSelected ? 'checked' : ''}
          />
          <label for="sort-checkbox-${sortMethod.handle}" class="c-facets__radio ${isSelected ? 'is-active' : ''} c-collection-faceted-nav__option-label">
            <span class="c-facets__radio-text">${sortMethod.title || sortMethod.name}</span>
          </label>
        </li>
      `;
    }).join('');

    const sortHtml = `
      <div class="c-collection-faceted-nav__facet-group" data-faceted-subnav>
        <ul class="c-facets__list">
          ${sortOptionsHtml}
        </ul>
      </div>
    `;

    $(this.sortElem).html(sortHtml);
  }

  onSortChange(e) {
    e.preventDefault();
    e.stopPropagation();
    
    const selectedCheckbox = e.target;
    const selectedSort = selectedCheckbox.getAttribute(ATTR_SORT_VALUE);
    
    if (selectedSort) {
      // Remove checked state from all sort options
      $(this.sortElem).find(`[${ATTR_SORT_VALUE}]`).each(function() {
        const checkbox = $(this);
        checkbox.prop('checked', false);
        checkbox.closest('.o-checkbox').removeClass('is-checked');
      });
      
      // Add checked state to selected option
      const $selectedCheckbox = $(selectedCheckbox);
      $selectedCheckbox.prop('checked', true);
      $selectedCheckbox.closest('.o-checkbox').addClass('is-checked');
      
      // Apply the sort
      this.template.sort.setSort(selectedSort);
    }
  }

  onLabelClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Find the associated checkbox
    const forAttr = e.target.getAttribute('for');
    const checkbox = $(this.sortElem).find(`#${forAttr}`)[0];
    
    if (checkbox) {
      // Trigger the checkbox click
      this.onSortChange({ target: checkbox, preventDefault: () => {}, stopPropagation: () => {} });
    }
  }

  onUpdate(selected) {
    // Update the visual state when the sort changes
    const selectedHandle = selected?.handle || selected;
    
    // Remove checked state from all options
    $(this.sortElem).find(`[${ATTR_SORT_VALUE}]`).each(function() {
      const checkbox = $(this);
      checkbox.prop('checked', false);
      checkbox.closest('.o-checkbox').removeClass('is-checked');
    });
    
    // Add checked state to the selected option
    if (selectedHandle) {
      const selectedCheckbox = $(this.sortElem).find(`[${ATTR_SORT_VALUE}="${selectedHandle}"]`);
      if (selectedCheckbox.length) {
        selectedCheckbox.prop('checked', true);
        selectedCheckbox.closest('.o-checkbox').addClass('is-checked');
      }
    }
  }

}